import React from 'react';
import { motion } from 'framer-motion';
import { Target, MousePointerClick, Megaphone } from 'lucide-react';

const metrics = [
  {
    icon: Target,
    title: 'CPA',
    line: 'Pay for outcomes, not guesses.',
    body: 'We optimize toward your target cost-per-acquisition. Beat the number — or beat it again.',
  },
  {
    icon: MousePointerClick,
    title: 'CPC',
    line: 'Efficient traffic that converts.',
    body: 'High-intent clicks from audiences that actually convert — not $4 visitors who never buy.',
  },
  {
    icon: Megaphone,
    title: 'Brand awareness',
    line: 'Reach audiences that grow your category.',
    body: 'Get in front of the buyers your competitors haven’t met yet — across the open web, not just the duopoly.',
  },
];

export default function WhatWeOptimize({ id = 'what-we-optimize-for', titleCase = false }) {
  return (
    <section id={id} className="relative py-24 md:py-32 bg-[#0B0F2A] text-white">
      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-4xl">
          <p className="text-sm sm:text-base font-semibold uppercase tracking-[0.22em] text-[#FF5081]">What we optimize for</p>
          <h2 className={`mt-5 font-display text-5xl sm:text-6xl lg:text-7xl font-semibold tracking-[-0.025em] leading-[1.02] ${titleCase ? 'capitalize' : ''}`}>
            You set the target. We hit it.
          </h2>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-4">
          {metrics.map((m, i) => (
            <motion.div
              key={m.title}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              className="rounded-2xl p-8 md:p-9 border border-white/10 bg-white/[0.03] hover:bg-white/[0.05] hover:border-white/20 transition-all"
            >
              <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-[#FF5081]/10 text-[#FF5081] border border-[#FF5081]/20">
                <m.icon className="w-[18px] h-[18px]" strokeWidth={1.75} />
              </span>
              <h3 className="mt-5 font-display text-2xl font-semibold tracking-tight">{m.title}</h3>
              <p className="mt-2 text-white/85 text-[15px] font-medium">{m.line}</p>
              <p className="mt-3 text-white/55 text-[15px] leading-relaxed">{m.body}</p>
            </motion.div>
          ))}
        </div>

        <div className="mt-14 max-w-3xl">
          <p className="text-lg lg:text-xl leading-relaxed text-white/65">
            Sellrly is built around the metric that matters to your business — and reported against it, plainly.
          </p>
        </div>
      </div>
    </section>
  );
}
